module.exports = __webpack_public_path__ + "static/media/apple.452ba4b3.svg";